import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';

import getters from './getters';

/********************************自动导入模块 start********************************/
const path = require('path');
const file = require.context('./modules', true, /\.js/);
let modules = {};
file.keys().forEach((key) => {
  const name = path.basename(key, '.js');
  modules[name] = file(key).default || file(key);
});
/********************************自动导入模块 end********************************/

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'vuex_app', // 存储名 默认都是vuex 多个模块需要指定 否则会覆盖
  // 只针对user模块下持久化,如果具体到那个state的时候可以eg:user.userInfo
  paths: ['user'],
});

export default createStore({
  modules,
  getters,
  plugins: [vuexLocal.plugin],
});
